import { cn } from '../../lib/cn';

interface GlowOrbProps {
  className?: string;
  color?: 'blue' | 'cyan' | 'lavender';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const colorMap = {
  blue: 'bg-brand-900',
  cyan: 'bg-brand-300',
  lavender: 'bg-lavender',
};

const sizeMap = {
  sm: 'w-64 h-64',
  md: 'w-96 h-96',
  lg: 'w-[600px] h-[600px]',
  xl: 'w-[900px] h-[900px]',
};

export function GlowOrb({
  className,
  color = 'blue',
  size = 'md',
}: GlowOrbProps) {
  return (
    <div
      aria-hidden
      className={cn('glow-orb', colorMap[color], sizeMap[size], className)}
    />
  );
}
